export const START_DATE = new Date('1999-01-01');
export const TODAY = new Date();
